import React, { useEffect, useState } from 'react';
import { Card } from '../components/Card';
import { StatusBadge } from '../components/StatusBadge';
import { historyExpenses } from '../utils/mockData';
import { ReceiptIcon, SearchIcon, XIcon, ArrowUpIcon, ArrowDownIcon } from 'lucide-react';
import { EmptyState } from '../components/EmptyState';
import { SkeletonCard } from '../components/Skeleton';
import { formatCurrency, formatDate } from '../utils/formatters';
import { Button } from '../components/Button';
export function History({
  navigateTo
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [sortBy, setSortBy] = useState('date');
  const [sortDirection, setSortDirection] = useState('desc');
  const [showFilters, setShowFilters] = useState(false);
  const [statusFilter, setStatusFilter] = useState('all');
  // Filter expenses based on search term and status filter
  const filteredExpenses = historyExpenses.filter(expense => (searchTerm ? expense.merchant.toLowerCase().includes(searchTerm.toLowerCase()) || expense.date.includes(searchTerm) : true) && (statusFilter !== 'all' ? expense.status === statusFilter : true)).sort((a, b) => {
    // Sort expenses based on selected sort criteria
    if (sortBy === 'date') {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
    } else if (sortBy === 'amount') {
      return sortDirection === 'asc' ? a.amount - b.amount : b.amount - a.amount;
    } else if (sortBy === 'merchant') {
      return sortDirection === 'asc' ? a.merchant.localeCompare(b.merchant) : b.merchant.localeCompare(a.merchant);
    }
    return 0;
  });
  const handleExpenseClick = expense => {
    setSelectedExpense(expense);
  };
  const closeDetails = () => {
    setSelectedExpense(null);
  };
  const toggleSortDirection = () => {
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
  };
  const handleSortChange = criteria => {
    if (sortBy === criteria) {
      toggleSortDirection();
    } else {
      setSortBy(criteria);
      setSortDirection('desc');
    }
  };
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);
  if (selectedExpense) {
    return <div className="p-4 max-w-md mx-auto" data-id="element-111">
        <div className="flex items-center mb-4" data-id="element-112">
          <button onClick={closeDetails} className="mr-2 p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Back to expense list" data-id="element-113">
            <XIcon size={20} className="text-gray-500" data-id="element-114" />
          </button>
          <h1 className="text-xl font-bold" data-id="element-115">Expense Details</h1>
        </div>
        <Card className="mb-4" data-id="element-116">
          <div className="flex justify-between items-center mb-4" data-id="element-117">
            <h2 className="text-lg font-semibold" data-id="element-118">
              {selectedExpense.merchant}
            </h2>
            <StatusBadge status={selectedExpense.status} data-id="element-119" />
          </div>
          <div className="bg-gray-50 p-3 rounded-lg mb-4" data-id="element-120">
            <img src="https://images.unsplash.com/photo-1572636583518-83f74e4ba355?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80" alt="Receipt" className="w-full h-40 object-cover rounded-lg" data-id="element-121" />
          </div>
          <div className="space-y-3" data-id="element-122">
            <div className="flex justify-between" data-id="element-123">
              <span className="text-gray-500" data-id="element-124">Date:</span>
              <span className="font-medium" data-id="element-125">
                {formatDate(selectedExpense.date)}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-126">
              <span className="text-gray-500" data-id="element-127">Amount:</span>
              <span className="font-medium" data-id="element-128">
                {formatCurrency(selectedExpense.amount)}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-129">
              <span className="text-gray-500" data-id="element-130">Category:</span>
              <span className="font-medium" data-id="element-131">Meals</span>
            </div>
            <div className="flex justify-between" data-id="element-132">
              <span className="text-gray-500" data-id="element-133">Submitted:</span>
              <span className="font-medium" data-id="element-134">Oct 16, 2025</span>
            </div>
            <div className="flex justify-between" data-id="element-135">
              <span className="text-gray-500" data-id="element-136">Attendees:</span>
              <span className="font-medium" data-id="element-137">3 people</span>
            </div>
          </div>
          {selectedExpense.status === 'Flagged' && <div className="mt-4 p-3 bg-red-50 rounded-lg border border-red-100" data-id="element-138">
              <p className="text-red-700 text-sm font-medium" data-id="element-139">
                Missing information
              </p>
              <p className="text-red-600 text-sm" data-id="element-140">
                Please provide the names of all attendees for this business
                meal.
              </p>
            </div>}
        </Card>
      </div>;
  }
  return <div className="p-4 max-w-md mx-auto" data-id="element-141">
      <div className="flex justify-between items-center mb-4" data-id="element-142">
        <h1 className="text-xl font-bold" data-id="element-143">Expense History</h1>
        <div className="flex" data-id="element-144">
          {showSearch ? <button onClick={() => setShowSearch(false)} className="p-2" aria-label="Close search" data-id="element-145">
              <XIcon size={20} className="text-gray-500" data-id="element-146" />
            </button> : <button onClick={() => setShowSearch(true)} className="p-2" aria-label="Search expenses" data-id="element-147">
              <SearchIcon size={20} className="text-gray-500" data-id="element-148" />
            </button>}
          <button onClick={() => setShowFilters(!showFilters)} className={`p-2 ml-2 ${showFilters ? 'bg-blue-100 rounded-full' : ''}`} aria-label="Filter expenses" data-id="element-149">
            <div size={20} className={showFilters ? 'text-blue-600' : 'text-gray-500'} data-id="element-150" />
          </button>
        </div>
      </div>
      {showSearch && <div className="mb-4 relative" data-id="element-151">
          <input type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Search by merchant or date" className="w-full p-2 pl-10 border rounded-lg" autoFocus data-id="element-152" />
          <SearchIcon size={18} className="absolute left-3 top-2.5 text-gray-400" data-id="element-153" />
          {searchTerm && <button onClick={() => setSearchTerm('')} className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600" aria-label="Clear search" data-id="element-154">
              <XIcon size={18} data-id="element-155" />
            </button>}
        </div>}
      {showFilters && <Card className="mb-4" data-id="element-156">
          <h3 className="font-medium mb-2" data-id="element-157">Filters</h3>
          <div className="mb-3" data-id="element-158">
            <label className="block text-sm text-gray-600 mb-1" data-id="element-159">Status</label>
            <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="w-full p-2 border rounded-lg" data-id="element-160">
              <option value="all" data-id="element-161">All Statuses</option>
              <option value="Approved" data-id="element-162">Approved</option>
              <option value="Under Review" data-id="element-163">Under Review</option>
              <option value="Flagged" data-id="element-164">Flagged</option>
            </select>
          </div>
          <div data-id="element-165">
            <label className="block text-sm text-gray-600 mb-1" data-id="element-166">Sort by</label>
            <div className="flex space-x-2" data-id="element-167">
              <button onClick={() => handleSortChange('date')} className={`px-3 py-1 rounded-lg text-sm ${sortBy === 'date' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100'}`} data-id="element-168">
                Date{' '}
                {sortBy === 'date' && (sortDirection === 'desc' ? <ArrowDownIcon size={14} className="inline ml-1" data-id="element-169" /> : <ArrowUpIcon size={14} className="inline ml-1" data-id="element-170" />)}
              </button>
              <button onClick={() => handleSortChange('amount')} className={`px-3 py-1 rounded-lg text-sm ${sortBy === 'amount' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100'}`} data-id="element-171">
                Amount{' '}
                {sortBy === 'amount' && (sortDirection === 'desc' ? <ArrowDownIcon size={14} className="inline ml-1" data-id="element-172" /> : <ArrowUpIcon size={14} className="inline ml-1" data-id="element-173" />)}
              </button>
              <button onClick={() => handleSortChange('merchant')} className={`px-3 py-1 rounded-lg text-sm ${sortBy === 'merchant' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100'}`} data-id="element-174">
                Merchant{' '}
                {sortBy === 'merchant' && (sortDirection === 'desc' ? <ArrowDownIcon size={14} className="inline ml-1" data-id="element-175" /> : <ArrowUpIcon size={14} className="inline ml-1" data-id="element-176" />)}
              </button>
            </div>
          </div>
        </Card>}
      {isLoading ? <>
          <SkeletonCard data-id="element-177" />
          <SkeletonCard data-id="element-178" />
          <SkeletonCard data-id="element-179" />
        </> : filteredExpenses.length === 0 ? <EmptyState icon={<ReceiptIcon size={24} className="text-gray-500" data-id="element-181" />} title="No expenses found" description={searchTerm ? 'Try adjusting your search terms' : "You haven't submitted any expenses yet"} data-id="element-180">
          <Button variant="outline" onClick={() => navigateTo('upload')} icon={<div size={20} data-id="element-183" />} data-id="element-182">
            Submit New Expense
          </Button>
        </EmptyState> : <div className="space-y-3" data-id="element-184">
          {filteredExpenses.map(expense => <Card key={expense.id} className="mb-3 transform transition-all hover:scale-[1.02]" onClick={() => handleExpenseClick(expense)} data-id="element-185">
              <div className="flex justify-between items-center" data-id="element-186">
                <div className="flex items-center" data-id="element-187">
                  <div className="bg-gray-100 p-2 rounded-full mr-3" data-id="element-188">
                    <ReceiptIcon size={18} className="text-gray-500" data-id="element-189" />
                  </div>
                  <div data-id="element-190">
                    <p className="font-medium" data-id="element-191">{expense.merchant}</p>
                    <p className="text-sm text-gray-500" data-id="element-192">
                      {formatDate(expense.date)}
                    </p>
                  </div>
                </div>
                <div className="flex flex-col items-end" data-id="element-193">
                  <p className="font-bold" data-id="element-194">{formatCurrency(expense.amount)}</p>
                  <StatusBadge status={expense.status} data-id="element-195" />
                </div>
              </div>
            </Card>)}
        </div>}
    </div>;
}